<template>
  <div class="dati">
    <navbar v-model="sidebar"></navbar>
    <sidebar v-model="sidebar"></sidebar>
    <b-btn class="float-export" size="lg" variant="success" v-on:click="exportCSV()">Esporta in CSV</b-btn>
    <div id="pivot"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import sidebar from '@/components/sidebar.vue'

import '@/assets/pivot.css'
import * as pivot from '@/assets/pivot.js'

var myPivot

export default {
  name: 'dati',
  components: {
    sidebar,
    navbar
  },
  watch: {
    'sidebar.cerca': function (newQuestion, oldQuestion) {
      this.filtra()
    },
    'sidebar.cercaAziende': function (newQuestion, oldQuestion) {
      this.filtraAziende()
    },
    'percentuale': function (newQuestion, oldQuestion) {
      this.filtra()
    }
  },
  data() {
    return {
      sidebar: this.$sidebar,
      percentuale: false
    }
  },
  mounted: function () {
    dhx.i18n.setLocale("pivot", {
      availableFields: "filtri disponibili",
      values: "dati",
      columns: "filtri colonna",
      rows: "filtri riga",
      moveFieldsHere: "",
      hideSettings: "Nascondi filtri",
      showSettings: "Mostra filtri",
      apply: "Salva",
      day: "Giorno",
      week: "Settimana",
      month: "Mese",
      quarter: "Quarter",
      year: "Anno",
      min: "Min",
      max: "Max",
      sum: "Sum",
      count: "Count",
      equal: "Uguale",
      notEqual: "Non Uguale",
      contains: "Contiene",
      notContains: "Non Contiene",
      typeHere: "Digita qui",
      selectAll: "Seleziona tutti",
      unselectAll: "Togli tutti",
      cancel: "Cancella",
      ok: "Ok",
      total: "Totale",
      date: {
        month_full: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        month_short: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
        day_full: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        day_short: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        quarter: ["Q1", "Q2", "Q3", "Q4"],
        week: "W"
      }
    })
    
    myPivot = new dhx.Pivot("pivot", {
      fields: {
        rows: ["indice"],
        columns: ["zona", "azienda", "trimestre", "anno"],
        values: [{ id: "value", method: "avg" }],
      },
      fieldList: [
        { id: "azienda", label: "azienda", sortDir: "asc" },
        { id: "zona", label: "zona" },
        { id: "trimestre", label: "trimestre", sortDir: "desc" },
        { id: "anno", label: "anno" },
        { id: "indice", label: "indice", sortDir: "asc" },
        { id: "value", label: " " }
      ],
      types: {
        operations: [
          { id: "avg", label: "Valori" },
          { id: "prc", label: "Percentuale" }
        ]
      }
    })

    myPivot.addMathMethod("avg", "Valori", (cellData) => {
      this.percentuale = false

      const sum = cellData.reduce((el, all) => all += el);
      return new Intl.NumberFormat('de-DE').format((sum / cellData.length).toFixed(2))
    })

    myPivot.addMathMethod("prc", "Percentuale", (cellData) => {
      this.percentuale = true

      const sum = cellData.reduce((el, all) => all += el);
      return new Intl.NumberFormat('de-DE').format((sum / cellData.length).toFixed(2))+"%"
    })

    this.filtra()
  },
  methods: {
    filtra(){
      myPivot.setData([{indice: "Caricamento in corso..."}])
      
      var data = {
        zona: this.$sidebarValue.zona,
        anno1: this.$sidebarValue.anno1,
        anno2: this.$sidebarValue.anno2,
        trimestre1: this.$sidebarValue.trimestre1,
        trimestre2: this.$sidebarValue.trimestre2,
        categoria: this.$sidebarValue.categoria,
        sottocategoria: this.$sidebarValue.sottocategoria,
        ricavi: this.$sidebarValue.ricavi,
        criterio: this.$sidebarValue.criterio,
        azienda: this.$sidebarValue.azienda,
        percentuale: this.percentuale,
        differenza: true
      }

      Vue.http.post(this.$hostlink+'data/filtro', data, {credentials : true}).then(response => {
        Vue.prototype.$sidebarValue.info = response.body.info
        myPivot.setData(response.body.data)
      })
    },
    filtraAziende(){
      document.getElementsByClassName('dhx_header_wrapper')[0].style.cssText = "position: sticky; top: 0px; height: 200px; width: 1424px; z-index: 0;"
      document.getElementsByClassName('dhx_pivot_settings_wrap')[0].style.cssText = "z-index: 0;"

      var data = {
        zona: this.$sidebarValue.zona,
        anno1: this.$sidebarValue.anno1,
        anno2: this.$sidebarValue.anno2,
        trimestre1: this.$sidebarValue.trimestre1,
        trimestre2: this.$sidebarValue.trimestre2,
        categoria: this.$sidebarValue.categoria,
        sottocategoria: this.$sidebarValue.sottocategoria,
        ricavi: this.$sidebarValue.ricavi,
        criterio: this.$sidebarValue.criterio
      }

      Vue.http.post(this.$hostlink+'data/filtro/aziende', data, {credentials : true}).then(response => {
        Vue.prototype.$sidebarValue.listaAziende = response.body
        
        Vue.prototype.$sidebar.trovatoAziende = !this.$sidebar.trovatoAziende
        this.$emit('input', this.$sidebar)
      })
    },
    exportCSV(){
      myPivot.export({
        name:"Dati",
        url:"//export.dhtmlx.com/excel"
      })
    }
  }
}
</script>

<style>
#pivot{
  height: calc(100vh - 56px);
}

.dhx_popup{
  z-index: 9999;
}

.float-export{
  position: absolute;
  top: 90px;
  left: 70%;
}
</style>
